import React from "react";

import { clsx } from "clsx";

import type { CheckboxProps } from "@busbud/horizon";
import { Checkbox } from "@busbud/horizon";

import { useLiteAppContext } from "@app/helpers/hooks";

export const AffiliateCheckbox = React.forwardRef<
  HTMLInputElement,
  CheckboxProps
>(({ className, ...props }, ref) => {
  const { liteTranslator } = useLiteAppContext();

  return (
    <Checkbox
      ref={ref}
      className={clsx("self-start", className)}
      id="affiliate_checkbox"
      labelText={liteTranslator.t("!search.affiliates.checkbox-text")}
      data-cy="affiliate-checkbox"
      variant="solid"
      {...props}
    />
  );
});
